import React from 'react';
import { useLocation } from 'react-router-dom';
import HeroBackground from '../../asset/HeroBackground.jpg';
import GroupAvatar from '../../asset/GroupAvatar.png';
import { BookingForm } from '../ui/BookingForm';

export const Hero = () => {
  const location = useLocation();

  const scrollToBookATour = () => {
    const element = document.getElementById('book-a-tour');
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section
      className="w-full flex flex-col sm:flex-row items-center justify-center sm:justify-between bg-[#fef4ea] sm:bg-cover sm:bg-center sm:bg-no-repeat mt-[55px] sm:mt-[65px] px-4 sm:px-8 lg:px-[65px] pt-[60px] sm:pt-[100px] pb-[30px] sm:pb-[50px]"
      style={{
        height: window.innerWidth >= 768 ? 'calc(100vh - 65px)' : 'auto',
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0, 0, 0, 0.5)), url(${HeroBackground})`
      }}
    >
      {/* Left Content */}
      <div className="w-full sm:w-[55%] flex flex-col justify-evenly text-center sm:text-left max-w-[700px]">
        <div className="relative mb-4">
          <h1 className="text-4xl sm:text-5xl md:text-[64px] lg:text-[90px] font-bold leading-tight sm:leading-[55px] md:leading-[70px] lg:leading-[100.28px] font-regrade text-[#f9f9f9]">
            <svg
              className="hidden sm:block absolute left-[8px] sm:left-[10px] lg:left-[14px] top-[120px] sm:top-[160px] md:top-[220px] lg:top-[289px] w-[180px] sm:w-[200px] md:w-[280px] lg:w-[345px] h-[50px] sm:h-[65px] md:h-[90px] lg:h-[109px] -rotate-[1.565deg]"
              viewBox="0 0 345 112"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.16957 87.2867C35.5416 136.707 332.697 102.633 344.026 55.6313C361.881 -18.4402 91.0487 -4.35116 53.0781 20.7682C51.6718 21.6985 51.9509 23.3385 53.1378 22.9518C156.972 -10.8795 348.173 3.47436 333.441 55.9205C315.897 96.0459 11.4958 132.726 8.76836 78.2145C6.97252 42.323 142.68 4.7629 241.813 12.8467C244.756 12.3203 242.376 10.4352 239.124 10.1105C132.823 1.49714 -21.5344 39.9669 3.16957 87.2867Z"
                fill="wheat"
              />
            </svg>
            <span>Affordable Workspace in the Heart of </span>
            <span className="flex flex-col sm:flex-row justify-center sm:justify-start items-center gap-2">
              <span className="text-[#FFB320]">
                Chennai<span className="text-[#f9f9f9]"> | </span>
              </span>
              <span className="flex flex-col text-2xl sm:text-[34px] font-bold leading-[26px] sm:leading-[37.06px] mt-2 sm:mt-0">
                <span>Starting at </span>
                <span className="text-[#38d600]">₹4,599</span>
              </span>
            </span>
          </h1>
        </div>

        <p className="text-[wheat] text-base sm:text-lg font-medium leading-[24px] sm:leading-[32.4px] mb-4 max-w-[495px] mx-auto sm:mx-0">
          Prime Location • Competitive Pricing • Flexible Terms
        </p>

        <div className="w-full flex flex-col sm:flex-row items-center gap-4">
          {/* Optional Button */}
          {/* <Button
            style={{ borderRadius: '30px' }}
            className="text-[15px] text-white rounded-[30px] px-5 hover:bg-[#7d5262] transition-colors w-full sm:w-auto"
            onClick={scrollToBookATour}
          >
            Experience Offis Bay
          </Button> */}
          <img
            src={GroupAvatar}
            alt="Group Avatar"
            className="w-[180px] sm:w-[230px] mt-4 sm:mt-0"
          />
        </div>
      </div>

      {/* Booking Form */}
      <div className="w-full sm:w-[45%] mt-10 sm:mt-0">
        <BookingForm />
      </div>
    </section>
  );
};
